import { makeObservable, observable, runInAction } from 'mobx';
import { BaseStore } from './baseStore';
import { RootStore } from './rootStore';
import { UserStore } from './userStore';
import { ParticipationService } from '/src/api';
import { Participation } from '/src/lib/models';
import { MenuItemType, TListParticipationsRequest, UserRole } from '/src/lib/types';

export interface ParticipationStoreProps {
  /**
   * List of Participations
   */
  participations?: Participation[];
}

export class ParticipationStore extends BaseStore implements ParticipationStoreProps {
  private didInitMenu = false;
  userStore: UserStore;

  participations?: Participation[];

  constructor(rootStore: RootStore) {
    super(rootStore);

    this.userStore = rootStore.userStore;

    makeObservable(this, {
      participations: observable,
    });
  }

  /**
   * Adds Participations nav menu items to the app header.
   */
  initMenuItems = () => {
    if (this.didInitMenu || !this.rootStore.userStore.user) return;

    // Add menu items
    this.rootStore.menuStore.addMenuItem(
      'topbar',
      'Participations',
      'participations',
      MenuItemType.Item,
      '/participations(/create)?',
      false,
      [UserRole.Admin],
      4
    );

    runInAction(() => (this.didInitMenu = true));
  };

  /**** Data Processing ****/

  /**
   * Formats List Participations responses.
   *
   * @param participations - An array of Participations to format
   * @returns The formatted Participations
   */
  formatParticipationList = (participations: Participation[]) => {
    // Format
    if (!this.userStore.isAdmin) {
      participations = participations.filter(
        (participation) => participation.lender._id === this.userStore.user?.company?._id
      );
    }

    // Return
    return participations;
  };

  /**** Participation CRUD ****/

  /**
   * Fetches a list of Participations.
   *
   * @param query - Optional query to send with the API request
   * @returns An array of Participations
   */
  query = async (query?: TListParticipationsRequest) => {
    // if (query) query.px = true;
    const response = await ParticipationService.query(query);

    runInAction(() => (this.participations = this.formatParticipationList(response)));

    return this.participations;
  };
}
